export const SELECTOR_COLUMN_WIDTH = 50;
export const SELECTOR_ID = '__selector';

export const DETAIL_EXPANDER_COLUMN_WIDTH = 35;
export const DETAIL_EXPANDER_ID = '__expander';

export const MIN_COL_SIZE = 100;
export const MAX_COL_SIZE = Number.MAX_VALUE;
